import { render, staticRenderFns } from "./edit-address.vue?vue&type=template&id=3a076c50"
import script from "./edit-address.vue?vue&type=script&lang=js"
export * from "./edit-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports